var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 82"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.655 48.688C12.825 48.688 0 61.468 0 77.243 0 79.87 2.138 82 4.773 82h62.454C69.862 82 72 79.87 72 77.243c0-15.775-12.825-28.555-28.655-28.555z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 41c11.361 0 20.571-9.178 20.571-20.5S47.361 0 36 0 15.429 9.178 15.429 20.5 24.639 41 36 41",
    opacity: 0.4
  }))));
};
export default SvgUser;